import SvgHighTemp from '../assets/icons/measurementIcons/HighTemp';
import SvgLowTemp from '../assets/icons/measurementIcons/LowTemp';
import SvgHumid from '../assets/icons/measurementIcons/Humid';
import SvgDry from '../assets/icons/measurementIcons/Dry';

import * as GiIcons from 'react-icons/gi';
import * as MDIcons from 'react-icons/md';
import {formatDateToString} from "./textFormatter";


export  const cyclePredKeyGen = (n) => {
	if(n === 'falling'){
		return 'rising_in';
	}else{
		return'falling_in';
	}
};

export const generateHistAPIURL = (l, com, regionName, d) => {
	if(l==='national'){
		return `/api/price/${com}/national/hist/from=${d}`
	} else {
		return `/api/price/${com}/${regionName}/hist/from=${d}`
	}
}
export const generateAPIURL = (a, l, r, d) => {
	//const apiURL = process.env.REACT_APP_API_URL;
	if (a === 'price'){
		if(l === 'national'){
			return `/api/nprices/${l}/date=${d}`;
		}
		else{
			return `/api/nprices/${l}/${r}/date=${d}`;
		}
	} else if (a ==='mst'){
		if(l === 'national'){
			return `/api/mst/${l}/date=${d}`;
		}
		else{
			return `/api/mst/${l}/${r}/date=${d}`;
		}
	}
};

export const generateMonthlyTimeSeriesAPIURL = (id, measurement) => {
	const lastMonth = new Date();
	lastMonth.setMonth(lastMonth.getMonth() - 1);

	// const debug = new Date("2023-02-06");
	// debug.setMonth(debug.getMonth() - 1);


	const dateString = formatDateToString(lastMonth)
	// const dateString = formatDateToString(debug)

	return `/api/${id}/${measurement}/from=${dateString}`
}

export const generateMonthlyHistogramAPIURL = (id, measurement) => {
	const lastMonth = new Date();
	lastMonth.setMonth(lastMonth.getMonth() - 1);

	// const debug = new Date("2023-02-06");
	// debug.setMonth(debug.getMonth() - 1);

	const dateString = formatDateToString(lastMonth)
	// const dateString = formatDateToString(debug)

	return `/api/${id}/${measurement}/hist/from=${dateString}`
}

export const  getInfoSVG = (m, i)=>{
	if (m==='temperature' && i===true){
		return <SvgHighTemp height={'inherit'} />;
	}
	else if (m==='temperature' && i===false){
		return <SvgLowTemp height={'inherit'} />;
	}
	else if((m==='relative_humidity' && i===true))
	{
		return <SvgHumid height={'inherit'} />;
	}
	else if((m==='relative_humidity' && i===false))
	{
		return <SvgDry height={'inherit'}/>;
	}

};

export const  getInterpTitle = (m, i)=>{
	if (m==='temperature' && i===true){
		return 'Suhu Tinggi';
	}
	else if (m==='temperature' && i===false){
		return 'Suhu Rendah';
	}
	else if((m==='relative_humidity' && i===true))
	{
		return 'Kelembapan Tinggi';
	}
	else if((m==='relative_humidity' && i===false))
	{
		return 'Kelembapan Rendah';
	}

};

export    const getIcons = (m, i)=>{
	if (m==='temperature' && i==='max'){
		return <GiIcons.GiThermometerHot />;
	}
	else if (m==='temperature' && i==='min'){

		return <GiIcons.GiThermometerCold />;
	}
	else if((m==='relative_humidity' && i==='max'))
	{
		return <MDIcons.MdWaterDrop />;
	}
	else if((m==='relative_humidity' && i==='min'))
	{
		return <MDIcons.MdOutlineWaterDrop />;
	}

};

export const interpHandler = (d, m) =>{
	const interp = d[`interp_${m}`];
	if(interp === 'high'){
		return true;
	} else {
		return false;
	}

};

export const getInterpValue = (d, n, i )=>{
	if(n==='temperature' && i===true){
		return `${d[`high_${n}`]}°C`;
	} else if(n==='temperature' && i===false){
		return `${d[`low_${n}`]}°C`;
	} else if(n==='relative_humidity' && i===true){
		return `${d[`high_${n}`]}%`;
	} else if(n==='relative_humidity' && i===false){
		return `${d[`low_${n}`]}%`;
	}
};

export const getTrendStatus = (m,s) =>{
	if(m === 'temperature'){
		if(s === 'falling'){
			return ['Turun', 'Mulai bergerak naik pada'];
		}else if(s === 'rising'){
			return ['Naik', 'Mulai bergerak turun pada'];
		}
	} else if( m === 'relative_humidity'){
		if(s === 'falling'){
			return ['Turun', 'Mulai bergerak naik pada'];
		}else if(s === 'rising'){
			return ['Naik', 'Mulai bergerak turun pada'];
		}
	} else {
		return '';
	}

};

export const standardizedEC = (conData, tempData) => {
	const conArr = conData.map(function (d) {
		return d.y;
	});
	const tempArr = tempData.map(function (d) {
		return d.y;
	});
	const sEC = [];

	for (let i = 0; i < conArr.length; i++) {
		const pow = tempArr[i]/26.815;

		const sec = conArr[i] * (0.4470 + (1.403 * Math.pow(Math.E, pow)));
		sEC.push(sec);
	}
	return sEC;

};

export const convertECtoPS = (conData) => {
	const conArr = conData.map((d) => {
		return d.y;
	});

	const PSArr = [];

	for(let i =0; i< conArr.length; i++){
		const practicalSalinity = (0.7317 * conArr[i]) - 3.7635;
		PSArr.push(practicalSalinity);
	}

	return PSArr;
};